import React from 'react';
import TimeRangePicker from '@/pages/components/TimeRangePicker';

export default function LibraryModalDateFilter({
  startDate = '',
  endDate = '',
  onChange,
  disabled = false,
}) {
  return (
    <div className="funding-library-modal__date-filter">
      <TimeRangePicker
        startDate={startDate}
        endDate={endDate}
        onChange={onChange}
        disabled={disabled}
      />
    </div>
  );
}
